import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormField } from '@angular/forms/signals';

import { GroupingExDirective } from './grouping-ex.directive';
import { GroupingExSignalDirective } from './grouping-ex-signal.directive';
import { GroupingExSelectionDirective } from './grouping-ex.selection.directive';
import { GroupingExSelectionGroupHeaderComponent } from './grouping-ex.selection.group-header.component';

const exportedModules = [
  GroupingExDirective,
  GroupingExSignalDirective,
  GroupingExSelectionDirective,
  GroupingExSelectionGroupHeaderComponent,
];

const declarations = [...exportedModules];

@NgModule({
  declarations: [declarations],
  exports: [exportedModules],
  imports: [CommonModule, FormField],
})
export class GroupingGridExModule {}
